import React, { useContext } from 'react';
import t from 'react-translate';
import { useSelector } from 'react-redux';
import { css } from '@emotion/react';

// redux
import { getAiRolePlay } from 'redux/selectors/timeline';

import { cardOverlaySize } from 'styles/global_defaults/scaffolding';
import NvTextArea from 'shared/components/inputs/nv-text-area';
import ClickableContainer from 'components/clickable-container';
import NvIcon from 'shared/components/nv-icon';
import AiConversationContext from './context';

const styles = css`
  min-height: ${cardOverlaySize}px;
  .send-message-textarea {
    width: 90%;
    textarea {
      border: none;
      background-color: transparent;
    }
  }
  .send-button {
    width: 10%;
  }
`;

const ChatBar = () => {
  const { aiRolePlayId } = useContext(AiConversationContext) || {};
  const aiRolePlay = useSelector((state) => getAiRolePlay(state, aiRolePlayId));

  return (
    <div css={styles} className='chat-bar w-100 align-items-center mt-auto py-4'>
      <div className='d-flex border-bottom w-100'>
        <NvTextArea
          className='send-message-textarea'
          placeholder={t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.SEND_MESSAGE_PLACEHOLDER()}
        />
        <ClickableContainer
          className='send-button'
          aria-label={t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.SEND_MESSAGE()}
        >
          <NvIcon
            icon='admin-image-right'
            size='small'
            className='d-flex align-items-center mb-4 mr-4 ml-auto text-gray-4'
          />
        </ClickableContainer>
      </div>
    </div>
  );
};

export default ChatBar;
